// extracted by css-extract-rspack-plugin
export default {"titleWrapper":"titleWrapper-HLIGrr","titleHeader":"titleHeader-DAjc1D","readOnly":"readOnly-JckP9o"};